import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-subscription-banner-trial-property',
  templateUrl: './subscription-banner-trial-property.component.html',
  styleUrls: ['./subscription-banner-trial-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SubscriptionBannerTrialPropertyComponent {
}
